import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

import { getCanUseApp } from '../../../../Resources/Organization/Apps/AppsData';
import RedirectTo from '../../../Common/RedirectTo';
import { JOB_COST } from '../AppsData';
import { openPaywall } from '../Redux/Actions';

const JobCostButton = () => {
  const canUseApp = useSelector(getCanUseApp(JOB_COST));
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    if (canUseApp) {
      RedirectTo.jobCosting();
    } else {
      dispatch(openPaywall());
    }
  };

  return (
    <Button variant="contained" color="primary" onClick={handleButtonClick}>
      {canUseApp ? 'Settings' : 'Upgrade your plan'}
    </Button>
  );
};

export default JobCostButton;
